import { useState } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import { signUp } from '../lib/auth';
import { AuthShell } from './Login';

export default function SignUp() {
  const [form, setForm] = useState({ displayName: '', email: '', phone: '', password: '' });
  const [error, setError] = useState('');
  const [sent, setSent]   = useState(false);
  const [busy, setBusy]   = useState(false);
  const nav = useNavigate();

  function set(k, v) { setForm(f => ({ ...f, [k]: v })); }

  async function onSubmit(e) {
    e.preventDefault();
    setError(''); setBusy(true);
    try {
      const { session } = await signUp(form);
      if (session) nav('/', { replace: true });
      else setSent(true);
    } catch (err) {
      setError(err?.message || 'Sign-up failed.');
    } finally { setBusy(false); }
  }

  if (sent) {
    return (
      <AuthShell title="Check your email">
        <p className="text-sm text-slate-600 mb-4">
          We sent a confirmation link to <span className="font-medium">{form.email}</span>.
          Click it to activate your account, then sign in. An admin may also need to approve your account.
        </p>
        <Link to="/login" className="btn-primary w-full">Back to sign in</Link>
      </AuthShell>
    );
  }

  return (
    <AuthShell title="Create your account">
      <form onSubmit={onSubmit} className="space-y-3">
        <div>
          <label className="label">Full name</label>
          <input className="input" value={form.displayName} onChange={e => set('displayName', e.target.value)} required />
        </div>
        <div>
          <label className="label">Email</label>
          <input type="email" className="input" value={form.email} onChange={e => set('email', e.target.value)} required />
        </div>
        <div>
          <label className="label">Phone</label>
          <input className="input" placeholder="+254…" value={form.phone} onChange={e => set('phone', e.target.value)} />
        </div>
        <div>
          <label className="label">Password (min 8 characters)</label>
          <input type="password" minLength={8} className="input" value={form.password} onChange={e => set('password', e.target.value)} required />
        </div>
        {error && <div className="text-red-700 text-sm">{error}</div>}
        <button disabled={busy} className="btn-primary w-full">
          {busy ? 'Creating…' : 'Create account'}
        </button>
        <div className="text-sm text-center">
          Already have an account? <Link to="/login" className="text-brand-600 hover:underline">Sign in</Link>
        </div>
        <p className="text-xs text-slate-500 text-center">
          New accounts are created with the <strong>sales</strong> role. An admin can change your role from the Users page.
        </p>
      </form>
    </AuthShell>
  );
}
